import { FormTab, RadioButtonGroupInput } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { VehicleSelectionGrid } from "./VehicleSelectionGrid";

const radioChoices = [
  {
    id: true,
    name: "Select all vehicles",
  },
  {
    id: false,
    name: "Select vehicles from the list",
  },
];

export const NotificationSubscriptionVehiclesTab = (props: any) => {
  return (
    <FormTab {...props} label="resources.admin-notifications.labels.vehicles">
      <div style={{ paddingTop: "20px", paddingLeft: "20px", width: "300px" }}>
        <ProtectedElement source="isAllVehiclesSelected">
          <RadioButtonGroupInput
            style={{ width: "100%", display: "flex", flexDirection: "row" }}
            label=""
            source="isAllVehiclesSelected"
            choices={radioChoices}
            row={true}
            defaultChecked={false}
          />
        </ProtectedElement>
      </div>

      <VehicleSelectionGrid {...props} />
    </FormTab>
  );
};
